module.exports = __webpack_public_path__ + "img/bg-car-thanks.a6f68bc3.jpg";